import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Redirect, Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { createStore } from 'redux';
import App from './App';
import Search from './containers/search/index';
import Profile from './containers/profile/index';

import AccessDeniedPage from './components/access-denied';
import PageNotFound from './components/page-not-found';

import reducer from './reducer';
import './index.scss';

const store = createStore(
  reducer
);

const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} onUpdate={() => window.scrollTo(0, 0)}>
      <Route component={App}>
        <Route path="/" component={Search} />
        <Route path="influencer/:slug" component={Profile} />
        <Redirect from="profile/:slug" to="influencer/:slug" />
        <Route path="denied" component={AccessDeniedPage} />
        <Route path="*" component={PageNotFound} />
      </Route>
    </Router>
  </Provider>
  , document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js